module.exports = __webpack_public_path__ + "static/media/headshot.332effab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headshot.png
// module id = 690
// module chunks = 0